 // add class when screen is small 

document.addEventListener('DOMContentLoaded', function() {
	// load swatch selected 
    const currentClick = document.querySelectorAll(`[currentClick="checked"]`);
    if(currentClick){ 
      currentClick.forEach( cc=> cc.click());
    }

    // add class when screen is small 
     let screenSize = window.screen.width;
     if(screenSize < 768 ){
       // load swatch selected 
       // console.log('log this size', screenSize);
       document.querySelector('.product__media-list_slider_data').classList.add('mobile__slide__data');
       document.querySelector('.thumbnail-list-update').classList.add('hide-on-mobile');
     }
  
    // this for desktop first image left and right arrow feature
      function customSliderClick(c_btn, c_s_btn){

            c_btn.addEventListener('click',function(){
              document.querySelector(`.${c_s_btn}`).click();
            });
      }
      let c_btn_prev  = document.querySelector('.c-btn-prev');
      let c_btn_next  = document.querySelector('.c-btn-next');

      if(c_btn_prev){customSliderClick(c_btn_prev,'c-slider-prev-btn');}
      if(c_btn_next){customSliderClick(c_btn_next,'c-slider-next-btn');}

      // const quantity__button_click = document.querySelectorAll('.quantity__button');

      // quantity__button_click.forEach( cc=> {

      //   cc?.addEventListener('click',function(){
      //     let update_quantity = document.querySelector('#quantity_updated_value').value;
      //     console.log(cc, "narsi",update_quantity);
      //   });
      // });\

      // let quantity__button_click = document.querySelector('#quantity_updated_value');

      // quantity__button_click.addEventListener('change',function(){
        
      //     let update_quantity = quantity__button_click.value;
      //     console.log( "narsi",update_quantity);
        
      // });


       const totalPriceUpdate = () => {
        let quantity = qty.value;
        let currentAmount = amount.dataset.sellingprice;
        currentAmount = currentAmount.replace("$", "");
        let total = quantity * currentAmount;
        amount.innerHTML = `$${total}`;
        let sale_amount_update = document.querySelector(".price-box .price__sale .price-item--last");
        sale_amount_update.innerHTML = `$${total}`;


        let compareAmount = document.querySelector(".price-box .price__sale .price-item--regular");
        if(compareAmount.dataset.comparePrice){
          let currentCompareAmount = compareAmount.dataset.comparePrice;
          currentCompareAmount = currentCompareAmount.replace("$", "");
          let total2 = quantity * currentCompareAmount;
          amount.innerHTML = `$${total2}`;
          let compare_amount_update = document.querySelector(".price-box .price__sale .price-item--regular");
          compare_amount_update.innerHTML = `$${total2}`;
        }     


      };
        
      let qty = document.querySelector(".submit__form__button .quantity__input");
      let amount = document.querySelector(".price-box .price-item--regular");
        
      if (window.location.href.indexOf("thelipbar-giftcard") != -1) {
        let giftCurrentValue = document.querySelectorAll(
          ".shade_options_box fieldset .swatch-labels"
        );
        giftCurrentValue.forEach((data) => {
          data.addEventListener("click", (data2) => {
            let updatedPrice = data2.target.parentElement.dataset.swatchValue;
            updatedPrice = updatedPrice.replace("$", "");
            amount.dataset.sellingprice = updatedPrice;
            setTimeout(totalPriceUpdate, 500);
          });
        });
      }
        
      qty.addEventListener("change", () =>{totalPriceUpdate()});
     
});




  

